import { atom } from 'recoil';

import { RemotePickMealPointWithId } from '~/types/platform/remotePickMealPoint';

const remotePickMealPointsList = atom<Array<RemotePickMealPointWithId>>({
  key: 'remotePickMealPointsList',
  default: [],
});

export default remotePickMealPointsList;
